import { SvgIcon, Typography, Button, Box, styled } from '@material-ui/core';
import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as GoogleIcon } from '../../../assets/google-icon.svg';
import { root } from '../../../theme/colors';

const StyledButton = styled(Button)({
  color: root[0],
  border: `1px solid ${root[200]}`
});

export const GOOGLE_SIGN_IN_BUTTON_ID = 'GOOGLE_SIGN_IN_BUTTON_ID';

const GoogleSignInButton = ({ onClick }) => {
  return (
    <StyledButton
      variant="outlined"
      fullWidth
      data-testid={GOOGLE_SIGN_IN_BUTTON_ID}
      onClick={onClick}
    >
      <SvgIcon component={GoogleIcon} />
      <Box marginLeft="14px">
        <Typography variant="button">Continuar com o Google</Typography>
      </Box>
    </StyledButton>
  );
};

GoogleSignInButton.propTypes = {
  onClick: PropTypes.func.isRequired
};

export default GoogleSignInButton;
